import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Button, Title, AddressInput, TextFieldInput, Switch, GenericModal } from '@gnosis.pm/safe-react-components'
import { useSafeAppsSDK } from '@gnosis.pm/safe-apps-react-sdk'
import { ethers } from 'ethers'

const Container = styled.div`
  padding: 1rem;
  width: 100%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const Toggles = styled.div`
  display: flex;
  flex-direction: row;
`
// interface for everything
const iface = new ethers.utils.Interface([
  'function addRecovery(address recoveryAddress, uint64 recoveryDate, uint8 recoveryType)',
  'function addRecoveryWithSubscription(address recoveryAddress, uint64 recoveryDate, uint8 recoveryType) payable',
  'function calculatePaymentAmount(uint256 recoveryDate, uint256 subscriptionAmount, uint8 recoveryType) public view returns (uint256)',
  'function getRecoveryDate(address safe) external view returns (uint64)',
  'function isModuleEnabled(address module) public view returns (bool)',
  'function enableModule(address module)',
  'function setGuard(address guard) external',
  'function clearRecoveryData() external'
])

const goerliChainId = 5;

const SafeApp = (): React.ReactElement => {
  const recoveryRegistry = '0x863e8137a13df881b6bc626374f5029e313f1886'
  const moduleAddress = '0x5616cc556C32AafDB46E5F7018c52b41bB20Cd90'
  // cast to any so i can access .ethereum
  const w: any = window;
  const { sdk, safe } = useSafeAppsSDK()
  const [onGoerli, setOnGoerli] = useState(safe.chainId == goerliChainId)
  const [isOpen, setIsOpen] = useState(false);
  const [address, setAddress] = useState<string>('');
  const [moduleEnabled, setModuleEnabled] = useState(false)
  const [inactivity, setInactivity] = useState(true);
  const [subscriptionMode, setSubscriptionMode] = useState(true);
  const [timestamp, setTimestamp] = useState<string>('120');
  const [recoveryActivated, setRecoveryActivated] = useState(false);

  useEffect(() => {
    const checkModuleEnabled = async () => {
      const chainId = await w.ethereum.request({ method: 'eth_chainId' });
      if (!onGoerli && parseInt(chainId, 16) != 5) {
        return;
      }

      try {
        const data = iface.encodeFunctionData('isModuleEnabled', [moduleAddress])
        const provider = new ethers.providers.Web3Provider(w.ethereum, 'any')
        const result = await provider.call({
          to: safe.safeAddress,
          data: data,
        })

        if (result == '0x0000000000000000000000000000000000000000000000000000000000000001') {
          setModuleEnabled(true);
        }
      } catch (e) {
        console.log(e, 'error')
      }
    }

    checkModuleEnabled()
      .then(async () => {
        const provider = new ethers.providers.Web3Provider(w.ethereum, 'any')
        const result = await provider.call({
          to: recoveryRegistry,
          data: iface.encodeFunctionData('getRecoveryDate', [safe.safeAddress])
        })

        if (result != '0x0000000000000000000000000000000000000000000000000000000000000000') {
          setRecoveryActivated(true)
        }
      })
      .catch(console.error)

  }, [safe, sdk])

  const onToggleInactivity = () => {
    const i = !inactivity;

    console.log('inactivity', inactivity)
    if (i) {
      setTimestamp(`120`);
    } else {
      setTimestamp(`${Math.round(Date.now() / 1000) + 120}`);
    }

    setInactivity(!inactivity);
  }

  const [recoveryEmail, setRecoveryEmail] = useState<string>();
  const [farewellMessage, setFarewellMessage] = useState<string>('Email notifications and message don\'t work at the moment. Auto execution of ownership transfer does.');
  const [ownerEmail, setOwnerEmail] = useState<string>();

  const renderErrorMsg = () => {
    return (
      <Container>
        <h1>Module is only available on Goerli testnet</h1>
      </Container>
    )
  }

  async function ensureOnGoerli() {
    w.ethereum.on('chainChanged', ensureOnGoerli);

    const chainId = await w.ethereum.request({ method: 'eth_chainId' });
    const isOnGoerli = safe.chainId == goerliChainId && parseInt(chainId, 16) == 5
    setOnGoerli(isOnGoerli);
    return isOnGoerli
  }

  ensureOnGoerli();



  const submitTx = async (e: any) => {
    e.preventDefault();

    let tx;
    const mode = inactivity == true ? 1 : 0


    if (subscriptionMode) {
      console.log('calculating')
      const provider = new ethers.providers.Web3Provider(w.ethereum, 'any')
      const res = await provider.call({
        to: recoveryRegistry,
        data: iface.encodeFunctionData('calculatePaymentAmount', [e.target.timestamp.value, ethers.utils.parseEther('0.001'), mode])
      })

      tx = {
        to: recoveryRegistry,
        value: res,
        data: iface.encodeFunctionData('addRecoveryWithSubscription', [e.target.address.value, e.target.timestamp.value, mode]),
      }
    } else {
      tx = {
        to: recoveryRegistry,
        value: ethers.utils.parseEther('0').toString(),
        data: iface.encodeFunctionData('addRecovery', [e.target.address.value, e.target.timestamp.value, mode]),
      }
    }

    try {
      // console.log(tx, 'What is TX:')
      const { safeTxHash } = await sdk.txs.send({
        txs: [tx],
      })
      setRecoveryActivated(true);
      const safeTx = await sdk.txs.getBySafeTxHash(safeTxHash)
      console.log(safeTx, 'what is this???')

      // POST REQUEST TO BACKEND to store this data to DB
      console.log(
        safe.safeAddress,
        ownerEmail,
        recoveryEmail,
        farewellMessage,
        '---------------------'
      )
    } catch (e) {
      console.error(e)
    }
  }

  const cancelRecovery = useCallback(async (e) => {
    try {
      const { safeTxHash } = await sdk.txs.send({
        txs: [
          {
            to: recoveryRegistry,
            value: '0',
            data: iface.encodeFunctionData('clearRecoveryData', []),
          },
        ],
      })

      await sdk.txs.getBySafeTxHash(safeTxHash)

      setRecoveryActivated(false);
    } catch (e) {
      console.error(e)
    }
  }, [safe, sdk])

  const enableModule = useCallback(async () => {
    try {
      const { safeTxHash } = await sdk.txs.send({
        txs: [
          {
            to: safe.safeAddress,
            value: '0',
            data: iface.encodeFunctionData('enableModule', [moduleAddress]),
          },
          {
            to: safe.safeAddress,
            value: '0',
            data: iface.encodeFunctionData('setGuard', [moduleAddress]),
          },
        ],
      })
      const safeTx = await sdk.txs.getBySafeTxHash(safeTxHash)
      setModuleEnabled(true)
    } catch (e) {
      console.error(e)
    }
  }, [safe, sdk])

  function showModal() {
    return (
      <div>
        <Button size="md" color="secondary" onClick={() => setIsOpen(!isOpen)}>
          Instructions
        </Button>
        {isOpen && (
          <GenericModal
            onClose={() => setIsOpen(false)}
            title="INSTRUCTIONS"
            withoutBodyPadding={true}
            body={<div>{showReadme()}</div>}
          />
        )}
      </div>
    )
  }

  function showReadme() {
    return (
      <Container>
        <a href='https://dev.to/bxmmm1/safe-recovery-module-1mf'>https://dev.to/bxmmm1/safe-recovery-module-1mf</a>
        <p>When this module is enabled, it storing the last transaction timestamp of that safe.</p>
        <h3>Module has 2 recovery methods:</h3>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <div style={{ padding: '10px', width: '20%' }}>
            <h3>
              Inactive for
            </h3>
            <p>
              Safe recovery process begins after the <strong>X</strong> amount of seconds <br></br> passes from the last Safe transaction.
            </p>
          </div>
          <div style={{ padding: '10px', width: '20%' }}>
            <h3>
              On Date
            </h3>
            <p>
              Safe recovery process starts on a future date.<br></br>
            </p>
          </div>
        </div>
        <h3>Subscription</h3>
        <p>
          If the subscription mode is turned on, you are paying for <strong>automatic transaction execution + notification system</strong><br></br>
          Safe owner is notified with email when the ownership transfer process begins.
          That process has a delay (10 minutes - in production it will be longer), so that the owner has enough time to cancel or make changes.<br></br>
          Safe Owner also can write a 'Farewell Message' and have it delivered to recipient's email address along with ownership transfer to a defined recipient address
        </p>
        <p><strong>If the subscription mode is off (free module usage), you are responsible for triggering transfer ownership functionality of a module</strong></p>
      </Container>
    )
  }


  function renderContent() {
    if (!moduleEnabled) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {showReadme()}
          <br></br>
          <Button disabled={false} color="secondary" id='module-btn' onClick={enableModule} size="lg" textSize='xl'>Enable Module</Button>
        </div>
      )
    }

    if (recoveryActivated) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Button disabled={false} color="secondary" id='module-btn' onClick={cancelRecovery} size="lg" textSize='xl'>Cancel Recovery</Button>
        </div>
      )
    }

    return (
      <Container>
        {showModal()}
        <Title size='lg'>Safe Recovery Module</Title>
        <p>Subscription mode has a cost for email notification and transaction execution services</p>
        <Toggles>
          <p>Subscription mode: <strong>{subscriptionMode ? 'ON' : 'OFF'}</strong></p>
          <Switch checked={subscriptionMode} onChange={() => setSubscriptionMode(!subscriptionMode)} />
          <p>Selected mode: <strong>{inactivity ? 'Inactive for' : 'On Date'}</strong></p>
          <Switch checked={inactivity} onChange={onToggleInactivity} />
        </Toggles>
        <form noValidate autoComplete="off" onSubmit={submitTx}>
          <AddressInput
            label="Recovery Address"
            name="address"
            placeholder={'Ethereum address'}
            address={address}
            onChangeAddress={setAddress}
          />
          <TextFieldInput
            id="recoveryTimestamp"
            label={inactivity ? 'Number of seconds since last safe tx' : 'Timestamp in future (2 min in future is pre-populated)'}
            name="timestamp"
            onChange={(e) => setTimestamp(e.target.value)}
            value={timestamp}
          />
          <TextFieldInput
            style={{ display: subscriptionMode ? 'block' : 'none' }}
            id="owner-email"
            disabled={true}
            label="Your email address"
            name="owner-email"
            onChange={(e) => setOwnerEmail(e.target.value)}
            placeholder="Owner email"
            value={ownerEmail}
          />
          <TextFieldInput
            style={{ display: subscriptionMode ? 'block' : 'none' }}
            id="recovery-email"
            disabled={true}
            label="Recovery email address"
            name="recovery-email"
            onChange={(e) => setRecoveryEmail(e.target.value)}
            placeholder="Recovery email"
            value={recoveryEmail}
          />
          <div style={{ height: '30%', marginBottom: '50px' }}>
            <textarea style={{ display: subscriptionMode ? 'block' : 'none', width: '100%', height: '100%' }} value={farewellMessage} onChange={e => setFarewellMessage(e.target.value)} />
          </div>
          <div>
            <Button id='submit-btn' variant="bordered" type="submit" size="lg">Submit</Button>
          </div>
        </form>
        {/* {// hide button if module is already enabled TODO: make it right} */}
        {/* <Button color="secondary" id='module-btn' onClick={cancelRecovery} size="md">CancelRecovery</Button> */}
      </Container>
    )
  }

  return (
    <Container>
      {!onGoerli ? renderErrorMsg() : renderContent()}
    </Container>
  )
}

export default SafeApp
